import { Component, computed, inject } from '@angular/core';

import { AuthStore } from '../../shared/state/auth.store';

import { meniuPentru } from './nav-left.model';
import { NavElementComponent } from './nav-element/nav-element.component';

@Component({
    selector: 'app-nav-left',
    templateUrl: './nav-left.component.html',
    styleUrls: ['./nav-left.component.scss'],
    imports: [NavElementComponent]
})
export class NavLeftComponent {
  private readonly authStore = inject(AuthStore);

  // meniul se recalculeaza din rolul din store, deci urmeaza orice autentificare noua
  protected readonly meniu = computed(() =>
    meniuPentru({ admin: this.authStore.isAdmin(), avizari: this.authStore.isAvizari() }));

}
